import React from 'react'
import GeneralInfoFieldCopy from './GeneralInfoFieldCopy'
import { Trans } from "react-i18next";

const GeneralInfoActionPanel = ({ onSubmit, onDelete, isEditing }) => (
  <div className="columns is-gapless">
    <div className="column has-text-left is-hidden-mobile">
      <GeneralInfoFieldCopy />
    </div>
    <div className="column has-text-right">
      <button className="button is-danger is-uppercase" onClick={onDelete}>
        <Trans>actions.delete.label</Trans>
      </button>{' '}
      <button
        className="button is-primary is-uppercase"
        onClick={onSubmit}
        type="submit"
        disabled={!isEditing}
      >
        <Trans>actions.save.label</Trans>
      </button>
    </div>
  </div>
)

export default GeneralInfoActionPanel



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GaneralInfoActionPanel.js